import { ChemistryQuiz } from '@efdigital/ll-xceed-v2/components/coaching/coachee/chemistry-quiz.gts';
import type { CoachingCoacheeCohortQuizModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/quiz';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import { scrollToTop } from '@efdigital/ll-xceed-v2/utils/application/scroll';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import Component from '@glimmer/component';

interface CoachingCoacheeCohortQuizSignature {
  Args: {
    model: CoachingCoacheeCohortQuizModel;
    controller: unknown;
  };
}

export default class CoachingCoacheeCohortQuiz extends Component<CoachingCoacheeCohortQuizSignature> {
  @service declare router: Router;
  @service declare coachee: CoacheeService;

  submitAnswer = () => {
    this.coachee.flushCachedRelevanceMatches(this.args.model.cohort_id);

    scrollToTop();
    if (!this.args.model.planner.coachHasBeenChosen) {
      this.router.transitionTo('coaching.coachee.cohort.coaches.index');
    }
  };

  <template>
    {{#if @model.chemistryQuiz}}
      <div class="container my-3">
        <div class="p-lg-5">
          <ChemistryQuiz
            @quiz={{@model.chemistryQuiz.quiz}}
            @answer={{@model.chemistryQuiz.answer}}
            @onSubmitted={{this.submitAnswer}}
            @initialMode={{if @model.hasPublishedAnswer "output" "input"}}
          />
        </div>
      </div>
    {{/if}}
  </template>
}
